/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const MissingKeyAction = {
    SkipCertificateOnlyEntry: 'SKIP_CERTIFICATE_ONLY_ENTRY',
    AddCertificateOnlyEntry: 'ADD_CERTIFICATE_ONLY_ENTRY'
} as const;

export type MissingKeyAction = typeof MissingKeyAction[keyof typeof MissingKeyAction];



